module.exports = __webpack_public_path__ + "img/partner-1.4d0562df.png";